import  gql  from 'graphql-tag'

export const economicActivities = gql`query {
        economicActivities{
            edges{
                node{
                    code
                    name
                    category
                }
            }
        }
    }`;
